<template>
  <div class="about">
    <BaseHero>
      <div class="hero-body">
        <h1 class="title">ABOUT</h1>
      </div>
    </BaseHero>
    <section class="container" style="padding-top: 5rem">
      <div class="columns">
        <div class="column is-10 is-offset-1">
          <div class="gi-card has-text-centered">
            <p>
              Gaming illuminaughty (Gi) is an entertainment & content creation
              organization founded in 2013.
            </p>
            <br />
            <p>
              Initially created as a podcast, Gi later expanded into other forms
              of content creation on various other platforms such as Youtube &
              Twitch. Their content is focused around gaming, music, anime, and
              lifestyle & fitness. With a vast array of unique and comedic
              personalities, Gi talent is sure to keep audiences engaged and
              entertained.
            </p>
            <br />
            <br />
            <router-link to="/creators" class="button is-secondary is-medium"
              >View our Creators</router-link
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseHero from "@/components/BaseHero";
export default {
  name: "Contact",
  components: { BaseHero },
};
</script>

<style lang="scss" scoped>
.about {
  min-height: 100vh;
}
@media only screen and (max-width: 43.75em) {
  .container {
    padding: 1rem;
  }
}
.gi-card {
  background: #0d0c10;
  border: 2px solid darken($color: #bf9c5a, $amount: 20);
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 1.5rem;
  text-align: left;
  // box-shadow: #9e8425 0px 1px 2px;
  h1,
  h2 {
    color: #d6b439;
  }
  img {
    max-width: 250px;
    margin-bottom: 2rem;
  }
  p {
    font-size: 1.4rem;
    letter-spacing: 0.03rem;
    font-weight: 300;
    line-height: 2rem;
    cursor: default;
  }
}
</style>
